import React, { useEffect } from 'react';
import { getUserManager } from 'domains/auth/Auth.util';

const SilentRenew = (): JSX.Element => {
  useEffect(() => {
    console.info('SilentRenew - signinSilentCallback');
    getUserManager()
      .signinSilentCallback()
      .catch((e) => {
        console.error('Unable to silent renew', e);
      });
  }, []);
  return <></>;
};

export default SilentRenew;
